// extracted by mini-css-extract-plugin
export var formContainer = "_gh-0";
export var message = "_gh-1";